module.exports = __webpack_public_path__ + "img/pqtl.6e41bb6b.png";